import  { type FC, memo, useCallback, useEffect, useRef } from "react";

import styles from "./Modal.module.scss";

export interface ModalProps {
  active: boolean;
  children?: JSX.Element[] | JSX.Element;
  handleClose: () => void;
  classWrapper?: string;
  classContaner?: string;
}

const Modal: FC<ModalProps> = memo((props) => { 
  const { active, handleClose, children, classWrapper, classContaner } = props;
  const rootRef = useRef<HTMLDivElement>(null);

  const rootClasses = {
    wrapper: [styles.modalWrapper, `${classWrapper}`],
    container: [styles.modalContainer, `${classContaner}`],
  };

  if (active) {
    rootClasses.wrapper.push(styles.modalWrapperActive);
    rootClasses.container.push(styles.modalContainerActive);
  }

  const clickOutside = useCallback((e: MouseEvent) => {
      if (rootRef.current && (e.target as Node).contains(rootRef.current) && handleClose) {
        handleClose();
      }
    },[handleClose]);

  useEffect(() => {
    if (!rootRef.current) return;

    const node = rootRef.current;

    node.addEventListener("mousedown", clickOutside);

    return () => {
    node.removeEventListener("mousedown", clickOutside);
    };
  }, [clickOutside]);


  return (
    <div ref={rootRef} className={rootClasses.wrapper.join(" ")}>
      <section className={rootClasses.container.join(" ")}>
        {children}
      </section>
    </div>
  );
}); 

Modal.displayName = "Modal";

export { Modal };
